import { render, staticRenderFns } from "./AutorizacaoDeleteDialog.vue?vue&type=template&id=1d0c3b47"
import script from "./AutorizacaoDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AutorizacaoDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports